import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { generatePath, useNavigate } from 'react-router';
import styled from 'styled-components';
import { Field, Form, Formik, FormikErrors } from 'formik';
import { DataCard } from '@sdir/sds';
import { ApplicationLayout } from '../Organisms/ApplicationLayout';
import ApplicationSteps from '../Molecules/ApplicationSteps';
import { routes } from '../Routes';
import FormToggle from '../Atoms/FormToggle';

const CRAPage: React.FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const requiredText = intl.formatMessage({ id: 'general.form.error' });

  const handleSubmit = useCallback(() => {
    const path = generatePath(routes.payment, { applicationUid: 'new' });
    navigate(path);
  }, [navigate]);

  const handleValidation = useCallback(
    (values: any) => {
      console.log('values: ', values);
      const errors: FormikErrors<any> = {};
      return Object.keys(errors).length ? errors : undefined;
    },
    [requiredText]
  );

  const initialValues = useMemo(() => {
    return {
      automatic: false,
    };
  }, []);

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} validate={handleValidation}>
      {({ submitForm, values }) => (
        <form noValidate>
          <ApplicationLayout
            canNavNext
            canNavBack
            heading={intl.formatMessage({ id: 'application.new.title' })}
            ingress={intl.formatMessage({ id: 'application.new.ingress' })}
            exitLabel={intl.formatMessage({ id: 'general.backtoapplications' })}
            navBackLabel={intl.formatMessage({ id: 'general.back' })}
            navNextLabel={intl.formatMessage({ id: 'general.next' })}
            timeline={<ApplicationSteps />}
            onNavNextClick={submitForm}
          >
            <DataCard>
              <CRAInfo>
                <h2>{intl.formatMessage({ id: 'application.cra.title' })}</h2>
                <p>{intl.formatMessage({ id: 'application.cra.description' })}</p>
                <FormContent>
                  <Field
                    name="automatic"
                    checked={values.automatic}
                    label={intl.formatMessage({ id: 'application.cra.automatic' })}
                    title={intl.formatMessage({ id: 'application.cra.automatic' })}
                    component={FormToggle}
                  />
                </FormContent>
              </CRAInfo>
            </DataCard>
          </ApplicationLayout>
        </form>
      )}
    </Formik>
  );
};

export default CRAPage;

const CRAInfo = styled.div`
  padding: 10px 35px 40px 35px;
  min-height: 400px;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;
